import { Controller, useFormContext } from 'react-hook-form';
import { Toggle } from 'rsuite';
import { SetupIPAHeader } from '../../SetupIPA/elements/SetupIPAHeader';
import styles from '../SetupFarma.module.scss';
import { SetupFarmaFormValues } from '../schema';
import { SetupPMCSourceSelector } from './SetupPMCSourceSelector';

type SetupPMCConfigurationProps = {
  isUpdating: boolean;
};

export const SetupPMCConfiguration = ({ isUpdating }: SetupPMCConfigurationProps) => {
  const { control, resetField, watch } = useFormContext<SetupFarmaFormValues>();
  const usePMCForIPAPricing = watch('usePMCForIPAPricing');

  return (
    <div className={styles['setup-farma__price-preference']}>
      <SetupIPAHeader
        title="PMC - Preço Máximo ao Consumidor"
        subtitle="Use o Preço Máximo ao Consumidor atualizado para garantir que os seus preços estejam de acordo com as regras"
      />
      <div className={styles['setup-farma__pmc-toggle-container']}>
        <Controller
          control={control}
          name="usePMCForIPAPricing"
          render={({ field }) => (
            <Toggle
              size="sm"
              checked={field.value}
              disabled={isUpdating}
              onChange={(checked: boolean) => {
                field.onChange(checked);
                // religar sem salvar volta a fonte para a salva (ou o padrão)
                if (checked) resetField('pmcConfig');
              }}
            />
          )}
        />
        <div className={styles['setup-farma__pmc-text']}>
          <p className={styles['setup-farma__pmc-title']}>Usar o PMC para precificar no IPA</p>
          <p className={styles['setup-farma__pmc-description']}>
            O PMC é o preço-teto autorizado para o comércio varejista de medicamentos. Garanta que os seus preços estejam dentro do teto.
          </p>
        </div>
      </div>
      {usePMCForIPAPricing && <SetupPMCSourceSelector disabled={isUpdating} />}
    </div>
  );
};
